/**
 * @generated SignedSource<<e4e3dfdf55ca5a6fa3754420f5d16995>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type parent_nativeIssueTable_ParentCell$data = {
  readonly parentIssue: {
    readonly fieldsById?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly __typename: string;
          readonly fieldId: string;
          readonly issueType?: {
            readonly avatar: {
              readonly small: string | null | undefined;
            } | null | undefined;
            readonly name: string;
          } | null | undefined;
          readonly text?: string | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly key: string;
    readonly summaryField?: {
      readonly text: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"parent_issueFieldParentReadviewFull_ParentReadView">;
  readonly " $fragmentType": "parent_nativeIssueTable_ParentCell";
};
export type parent_nativeIssueTable_ParentCell$key = {
  readonly " $data"?: parent_nativeIssueTable_ParentCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"parent_nativeIssueTable_ParentCell">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "text"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "parent_nativeIssueTable_ParentCell",
  "selections": [
    {
      "concreteType": "JiraIssue",
      "kind": "LinkedField",
      "name": "parentIssue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "key"
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "concreteType": "JiraSingleLineTextField",
              "kind": "LinkedField",
              "name": "summaryField",
              "plural": false,
              "selections": (v0/*: any*/)
            }
          ]
        },
        {
          "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "ids",
                  "value": [
                    "issuetype",
                    "summary"
                  ]
                }
              ],
              "concreteType": "JiraIssueFieldConnection",
              "kind": "LinkedField",
              "name": "fieldsById",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JiraIssueFieldEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "__typename"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "fieldId"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "concreteType": "JiraIssueType",
                              "kind": "LinkedField",
                              "name": "issueType",
                              "plural": false,
                              "selections": [
                                {
                                  "concreteType": "JiraAvatar",
                                  "kind": "LinkedField",
                                  "name": "avatar",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "ScalarField",
                                      "name": "small"
                                    }
                                  ]
                                },
                                {
                                  "kind": "ScalarField",
                                  "name": "name"
                                }
                              ]
                            }
                          ],
                          "type": "JiraIssueTypeField"
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": (v0/*: any*/),
                          "type": "JiraSingleLineTextField"
                        }
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "fieldsById(ids:[\"issuetype\",\"summary\"])"
            }
          ]
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcparentfromissueviewrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "parent_issueFieldParentReadviewFull_ParentReadView"
        }
      ]
    }
  ],
  "type": "JiraParentIssueField"
};
})();

(node as any).hash = "e9c64431688deaaeef9da35f41c83439";

export default node;
